export default class Cmd
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.Cmd";
	static Alert = "alert";
	static CloseForm = "closeForm";
	static DoCloseForm = "doCloseForm";
	static OpenForm = "openForm";	//TODO
	static OpenMainForm = "openMainForm";	//TODO 
	static RecordNew = "recordNew";
	static RecordSave = "recordSave";
	static RecordDelete = "recordDelete";
	static RecordRestore = "recordRestore";
	static ExecuteQuery = "executeQuery";
	static UpdateQuery = "updateQuery";
	static FetchAll = "fetchAll";
	static WriteField = "writeField";
	static DoWriteField = "doWriteField";	//待调整
	static RestoreParent = "restoreParent";
	static OpenURL = "openURL";
	static OpenResource = "openResource";
	static FormCmd = "formCmd";
	static WriteEditor = "writeEditor";	//待调整
	static DoWriteEditor = "doWriteEditor";	//待调整
	static WriteImage = "writeImage";
	
	static Js = "js";
	static Npapi = "npapi";
	static ShowDialog = "showDialog";
	
	static FadeInfo = "fadeInfo";
	static UpdateControlVisible = "updateControlVisible";//related createpolicy
	static UpdateControlShowDecimal="updateControlShowDecimal";
	static UpdateControlAllowEdit = "updateControlAllowEdit";//related createpolicy
	static UpdateControlLabel = "updateControlLabel";//related createpolicy
	static UpdateControlSkipTab = "updateControlSkipTab";
	
	static DS_AllowAdd = "ds_AllowAdd";
	static DS_AllowDelete = "ds_AllowDelete";
	static DS_AllowQuery = "ds_AllowQuery";
	static DS_AllowChangeQuery = "ds_AllowChangeQuery";
	static DS_AllowSave = "ds_AllowSave";
	static DS_AllowExport = "ds_AllowExport";
	static DS_AllowAttachment = "ds_AllowAttachment";
	static DS_AllowEdit = "ds_AllowEdit";
	
	
	static TmpRecordAdd  = "tmpRecordAdd";
	static TmpRecordDelete = "tmpRecordDelete";
	static TmpRecordClear = "tmpRecordClear";
	static TmpRecordRefresh = "tmpRecordRefresh";
	//				背景颜色			背景图片
	//Contianer-->backgroundColor,backgroundImage 
	//			最大大小			最小大小		最大宽度		最大高度			文件类型限制（仅上传）	最小宽度			最小高度			是否压缩
	//Image-->size,			sizeMin,		width,		height,			suffix,					widthMin,		heightMin,		compress
	//						是否密码框			是否禁用输入法		当为密码框时 密码显示的长度
	//StringEditor --> "displayAsPassword","imeEnable",			"passwordFixedLength"
	static SetControlProperty = "setControlProperty";//related createpolicy
	static SetFormDataSourceGroupProperty = "setFormDataSourceGroupProperty";
	
	static UpdateQueryForm = "updateQueryForm";
	static UpdateQueryCurrent = "updateQueryCurrent";
	static ActiveRecord = "activeRecord";
	static ShowImage = "showImage";
	static FileUploadCmd = "fileUpload";
	static FileDownload = "fileDownload";
	static ShowInfo = "showInfo";
	
	static SetRecordConditionTask = "setRecordConditionTask";
	static SetFormParamConditionTask = "setFormParamConditionTask";
	//public final static String SetRecordConditionTask = "setRecordConditionTask";
	//public static const FormParamConditionTasks:String = "formParamConditionTasks";
	
	static RefreshPlugin = "refreshPlugin";
	
	static FocusIn = "focusIn";
	static SwitchToTabPage = "switchToTabPage";
	//private static const LockMode:String = "lockMode";	//待调整
	
	static ParentCmdResult = "parentCmdResult";
	static LookupReturn = "lookupReturn";
	
	static ClientRecordRemove = "clientRecordRemove";
	static WriteDataMethodField = "writeDataMethodField";
	
	
	static LocateRecord = "locateRecord";
	
	static ButtonOk = "buttonOk";
	static ContextMap = "contextMap";
	
	static SortComponent = "sortComponent";
	static SortFormItem = "sortFormItem";
	
	static ShowClipboard = "showClipboard";
	
	//public static const UpdateFieldShowLookup:String = "updateFieldShowLookup";
	
	static UpdateEditorShowLookup = "updateEditorShowLookup";
	
	//public static const UpdateFieldShowMainForm:String = "updateFieldShowMainForm";
	
	static UpdateEditorShowMainForm = "updateEditorShowMainForm";
	
	static OpenLookup = "openLookup"
	static UpdateGroupCollapseState = "updateGroupCollapseState"
	static CreateTimer = "createTimer";
	static CancelTimer = "cancelTimer";
	
	//public static const SelectAllRecords:String = "selectAllRecor"
	static SelectRecords = "selectRecords";
	static LocateToRecord = "locateToRecord";
	
	//public static const SetDataGridRowHeight:String = "setDataGridRowHeight";
	static BindEditorStyle = "bindEditorStyle";
	static BindRowStyle = "bindRowStyle";
	static RemoveRowStyle = "removeRowStyle";
	static RemoveEditorStyle = "removeEditorStyle";
	static SetTextStyle = "setTextStyle";
	static SetButtonStyle = "setButtonStyle";
	static SetContainerStyle = "setContainerStyle";
	static ClientRecordAdd = "clientRecordAdd";
	static ClientRecordRefresh = "clientRecordRefresh";

	static SetFormTitle = "setFormTitle";

	static DimSortFormItem = "dimSortFormItem";
	static DimAdjustFormDataSourceField = "dimAdjustFormDataSourceField";
	static UpdateToolBar = "updateWorkflowToolBar";

	static HoldFocusIn = "holdFocusIn";
	static RegisterRender = "registerRender";
	static DragStart = "dragStart";
	static ShowCalculator = "showCalculator";

	static SysReinitForm = "sysReinitForm";

	static ShowClipboard = "showClipboard"

	static CallClientMethod = "callClientMethod";

	static UpdateDropDownContent = "updateDropDownContent";

	static OpenSubForm = "openSubForm";

	static Ds_AttachmentAllowVisible = "ds_AttachmentAllowVisible";
	static Ds_AttachmentAllowUpload = "ds_AttachmentAllowUpload";
	static Ds_AttachmentAllowRename = "ds_AttachmentAllowRename";
	static Ds_AttachmentAllowDelete = "ds_AttachmentAllowDelete";
	static OpenLuckySheet = "openLuckySheet";
	static UpdateAllowEditorNotSelectAll = 'updateAllowEditorNotSelectAll';
	static PrintReport = "printReport";
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/Cmd.js